module.exports = __webpack_public_path__ + "static/a_lee-4f856bbb12e0e7c39534bfb942b18465.jpeg";